import { Link } from "react-router-dom";
import { useArticles } from "../../../hooks/useArticles";
import { toNewsItems } from "../../../lib/articleAdapter";
import { matchesCategory } from "../../../lib/categoryAliases";
import NewsCard from "../../home/components/NewsCard";
import { AdSidebar } from "@/components/feature/SponsorAds";

interface AeropuertosGridProps {
  categoryFilter?: string;
}

export default function AeropuertosGrid({ categoryFilter = "Todas" }: AeropuertosGridProps) {
  const { articles, loading } = useArticles("Aeropuertos", false);

  // Filter articles by category/tag if a specific category is selected
  const allNewsItems = toNewsItems(articles);
  const newsItems = categoryFilter === "Todas"
    ? allNewsItems.slice(0, 9)
    : allNewsItems.filter((item) =>
        matchesCategory(
          item.category || "",
          Array.isArray(item.tags) ? item.tags : [],
          categoryFilter,
        ),
      ).slice(0, 9);

  return (
    <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-12">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <div className="w-1 h-7 bg-red-600 rounded-full" />
          <h2 className="text-[#0B1F3A] font-bold" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "1.6rem" }}>
            ÚLTIMAS NOTICIAS · AEROPUERTOS
          </h2>
        </div>
        <Link to="/actualidad" className="text-red-600 text-sm font-medium hover:underline cursor-pointer hidden sm:flex items-center gap-1 whitespace-nowrap" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          Ver todas <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* News grid */}
        <div className="lg:col-span-3">
          {loading ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="h-72 bg-slate-200 rounded-2xl animate-pulse" />
              ))}
            </div>
          ) : newsItems.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {newsItems.map((item) => (
                <NewsCard key={item.id} item={item} variant="default" />
              ))}
            </div>
          ) : (
            <div className="bg-white rounded-2xl border border-slate-100 p-10 text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-slate-100 rounded-full mx-auto mb-4">
                <i className="ri-newspaper-line text-slate-400 text-2xl" />
              </div>
              <p className="text-slate-400 text-sm" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                Aún no hay noticias de aeropuertos
              </p>
              <p className="text-slate-300 text-xs mt-1" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                Se mostrarán automáticamente cuando se publiquen desde el admin
              </p>
            </div>
          )}
        </div>

        {/* Publicidad (columna derecha) */}
        <aside className="lg:col-span-1">
          <AdSidebar
            placement="Aeropuertos"
            placeholders={[
              { title: "Sector Aeronáutico", desc: "Llega a miles de lectores especializados", format: "mediano" },
              { title: "Turismo & Viajes", desc: "Conecta con viajeros del Caribe dominicano" },
            ]}
          />
        </aside>
      </div>
    </div>
  );
}
